function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { combineClasses } from '@bydesign-ui/utils';
import { getDefaultOffset } from '@bydesign-ui/hooks';
import { useConfig, useDirection, usePrefixCls } from '@byte-design/config';
import { RcPopover } from '../../units/popover-wrapper';
var dirPrefix = {
  left: -1,
  top: -1,
  right: 1,
  bottom: 1
};
var arrowOffsetForPlacement = {
  'left-start': {
    x: 0,
    y: 10
  },
  'left-end': {
    x: 0,
    y: -10
  },
  'right-start': {
    x: 0,
    y: 10
  },
  'right-end': {
    x: 0,
    y: -10
  },
  'top-start': {
    x: 16,
    y: 0
  },
  'top-end': {
    x: -16,
    y: 0
  },
  'bottom-start': {
    x: 16,
    y: 0
  },
  'bottom-end': {
    x: -16,
    y: 0
  }
};
export function PopoverContent(props) {
  var triggerIds = props.triggerIds,
      arrow = props.arrow,
      _props$offset = props.offset,
      offset = _props$offset === void 0 ? getDefaultOffset() : _props$offset,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      className = props.className,
      arrowOffset = props.arrowOffset,
      extra = _objectWithoutProperties(props, ["triggerIds", "arrow", "offset", "placement", "className", "arrowOffset"]);

  var rtl = useDirection() === 'rtl';
  var popoverCls = combineClasses(usePrefixCls('popover', {
    rtl: rtl
  }), className);

  var _useConfig = useConfig(),
      popoverArrowOffset = _useConfig.popoverArrowOffset;

  var realOffset = _objectSpread({}, offset);

  if (arrow) {
    var _placement$split = placement.split('-'),
        _placement$split2 = _slicedToArray(_placement$split, 1),
        dir = _placement$split2[0];

    var isVertical = dir === 'top' || dir === 'bottom';
    Object.assign(realOffset, {
      x: offset.x + (!isVertical ? dirPrefix[dir] * popoverArrowOffset : 0),
      y: offset.y + (isVertical ? dirPrefix[dir] * popoverArrowOffset : 0)
    });
  }

  var arrowCls = {
    left: usePrefixCls('popover-arrow', {
      dir: 'left'
    }),
    right: usePrefixCls('popover-arrow', {
      dir: 'right'
    }),
    top: usePrefixCls('popover-arrow', {
      dir: 'top'
    }),
    bottom: usePrefixCls('popover-arrow', {
      dir: 'bottom'
    })
  };
  var arrowInnerCls = usePrefixCls('popover-arrow-inner');
  var getArrow = useCallback(function (arrowInfo) {
    var arrCls = arrowCls[arrowInfo.arrowDirection];
    return React.createElement("span", {
      className: arrCls
    }, React.createElement("span", {
      className: arrowInnerCls
    }));
  }, []);
  return React.createElement(RcPopover, Object.assign({}, extra, {
    className: popoverCls,
    getArrow: getArrow,
    arrow: arrow,
    placement: placement,
    offset: realOffset,
    triggerIds: triggerIds,
    arrowOffset: arrowOffset || arrowOffsetForPlacement[placement] || getDefaultOffset()
  }));
}